import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';

import { limpiarProductoConfiguracion, obtenerProductoConfiguracion } from '../../../actions/configuracion';

import { formatNumber } from '../../../utils/generalFunctions';

import { CustomValueContainer } from '../../../components/react_select/ReactSelect';

const DetallesProducto = ({ producto, reestablecerProducto }) => {

    const dispatch =  useDispatch();

    const { detalles } = useSelector(state => state.configuracion.productos);

    const [preciosModal, setPreciosModal] = useState(false);

    const [productoData, setProductoData] = useState({
        id: null,
        nombre: null, 
        precio_venta: null
    });

    const [unidadData, setUnidadData] = useState(null);
    const [unidadesFilter, setUnidadesFilter] = useState([]);

    let styles_select = {
        menuPortal: base => ({ ...base, zIndex: 9999 }), 
        container: (provided, state) => ({
            ...provided
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            overflow: "visible", 
            marginTop: "15px"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            position: "absolute",
            top: state.hasValue || state.selectProps.inputValue ? -15 : "0%",
            transition: "top 0.1s, font-size 0.1s",
            fontSize: (state.hasValue || state.selectProps.inputValue) && 13
        })
    };

    /* Precios producto */
    const handleAbrir = () => {
        dispatch(obtenerProductoConfiguracion(producto?.id));

        setProductoData({
            ...productoData,
            id: producto?.id
        });
    }

    const handleSelectUnidad = (option) => {
        setUnidadData(option);
    }

    const handleCerrar = () => {
        setProductoData({
            id: null,
            nombre: null, 
            precio_venta: null
        });
        setPreciosModal(false);
        reestablecerProducto(null);
    }

    useEffect(() => {
        dispatch(limpiarProductoConfiguracion());
    }, []);

    useEffect(() => {
        if(producto){
            setPreciosModal(true);
        }
    }, [producto]);

    useEffect(() => {
        if(detalles){
            console.log(detalles);

            setProductoData({
                ...productoData,
                id: detalles?.id, 
                nombre: detalles?.nombre, 
                precio_venta: detalles?.precio_venta
            });

            for (var i = 0; i < detalles?.unidades_precios?.length; i++) {
                if(!unidadData){
                    if(detalles?.unidades_precios[i]?.cantidad == 1) {
                        setUnidadData(detalles?.unidades_precios[i]);
                    }
                }
            }

            setUnidadesFilter(detalles?.unidades_precios);
        }
    }, [detalles]);

    return (
        <Modal show={preciosModal} backdrop="static" size="md" centered onEntered={() => handleAbrir()} onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Precios de producto</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="offset-md-6 col-md-6 form-group mb-2">
                        <div className="input-group h-100">
                            <Select
                                name="unidad"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Unidad"
                                options={unidadesFilter}
                                value={unidadData}
                                onChange={(value) => handleSelectUnidad(value)}
                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                components={{
                                    ValueContainer: CustomValueContainer
                                }}
                                styles={{ ...styles_select }}
                            />
                        </div>
                    </div>
                </div>
                
                <div className="row mt-3">
                    <div className="col-md-8">
                        <label className="fw-bold">Producto</label>
                        <p>{productoData?.nombre || 'Sin definir'}</p>
                    </div>

                    <div className="col-md-4">
                        <label className="fw-bold">Total</label>
                        <p>{formatNumber((productoData?.precio_venta || 0) / parseFloat(unidadData?.cantidad || 1), 2, '$ ', '')}</p>
                    </div>
                </div>                    
            </Modal.Body>
        </Modal>
    )
}

export default DetallesProducto;